var _parent = {};

module.exports = {
  init: (p) => (_parent = p),

  /**
   * Find which region a location belongs to
   *
   * @param {Array} geopoint The coordinates of the location as [longitude, latitude], quantities as float
   * @returns {BigInteger} Returns the ID of the region that the geopoint is inside of
   *
   */

  //NOTE: I changed the variable to non-nullable because passing null returned all regions

  getByCoords: (geopoint) =>
    _parent.gql.query(
      `query sdk_get_region_by_coordinates($point: geometry!) {
            regions(where: { geofence: { _st_contains: $point }}) {
                id
                name
                status
            }
        }`,
      {
        point: {
          type: "Point",
          coordinates: geopoint,
          crs: {
            type: "name",
            properties: { name: "EPSG:4326" },
          },
        },
      }
    ),
};
